// extracted by mini-css-extract-plugin
export default {"tabs":"v6-z","tablist":"w6-z","tablistItem":"x6-z"};